import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class TemplateService extends ServiceBase {
    /**
     * Fetches all approved templates for the current user.
     * @returns {Promise}
     */
    getTemplates = () => {
        const url = `${baseUrl}/${service}/templates`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Saves a new or updated template note.
     * @param {object} dto - { rk?, title, body, format, templateVer }
     * @returns {Promise}
     */
    saveTemplate = (dto) => {
        const url = `${baseUrl}/${service}/templates`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: dto }, config);
    };
}

const templateService = new TemplateService();
export default templateService;
